import { FlexContainer } from '@act/storybook';
import { FormControlLabel, Switch, Typography } from '@mui/material';

export interface ReportSectionSettingToggleProps {
  label: string;
  value: boolean;
  disabled?: boolean;
  /** Sidebar rows use a minimal label-above-switch layout. */
  compact?: boolean;
  onChange: (value: boolean) => void;
}

/**
 * Compact on/off switch for report section settings (include, callout, slides).
 * @param label - Setting name shown beside or above the control.
 * @param value - Whether the setting is enabled.
 * @param disabled - Disables interaction when true.
 * @param compact - Uses a narrow stacked layout for the section sidebar.
 * @param onChange - Called with the new boolean value.
 */
const ReportSectionSettingToggle = ({
  label,
  value,
  disabled = false,
  compact = false,
  onChange,
}: ReportSectionSettingToggleProps) => {
  const control = (
    <Switch
      size="small"
      checked={value}
      disabled={disabled}
      onChange={event => onChange(event.target.checked)}
      onClick={event => event.stopPropagation()}
    />
  );

  if (compact) {
    return (
      <FlexContainer
        direction="row"
        alignItems="center"
        gap={0.25}
        height="auto"
        overflowAllVisible={true}
        flexShrink={0}
      >
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        {control}
      </FlexContainer>
    );
  }

  return (
    <FormControlLabel
      label={label}
      control={control}
    />
  );
};

export default ReportSectionSettingToggle;
